module.exports = __webpack_public_path__ + "img/philippines-logo-icon.9f6a9873.png";